import React, { useState, useEffect } from 'react';
import { IEditorProps } from './props-interfaces';
import { config } from 'config';
import { SchemaSubmitForm } from '@restspace/schema-form';
import { metaSchema, toFieldSpec, toSchema, representableAsFieldSpec } from 'data/schema';

export const SchemaFormEditor = ({
    path, mimeType, onDirty, operation
}: IEditorProps) => {
    const [ value, setValue ] = useState({});
    const [ schema, setSchema ] = useState({});
    const [ formError, setFormError ] = useState('');

    useEffect(() => {
        if (operation === 'new') { // new item
            setSchema(metaSchema);
            setValue({});
            setFormError('');
        } else {
          config.api.fetchSchema(path)
            .then((schema) => {
                if (!representableAsFieldSpec(schema)) {
                    setFormError('This schema is too complex for this editor, edit directly in JSON');
                } else {
                    setSchema(metaSchema);
                    setValue(toFieldSpec(schema as object));
                    setFormError('');
                }
            })
            .catch((err) => {
                console.log('item load failed: ' + err);
                setFormError('Failed to load data');
            });
        }
    }, [ path, mimeType, operation ]);

    function makeSubmitLink(onClick: () => void) {
        return (
        <div className="jd-submit-button-container">
            <button type="button" className="jd-submit-button" onClick={onClick}>
            Submit
            </button>
        </div>
        );
    }

    const onDoSubmit = async (value: object) => {
        const newSchema = toSchema(value);
        const res = await config.api.saveItem(path, newSchema, mimeType);
        if (res) {
            alert('There was a problem, the changes were not saved: ' + res);
            return false;
        }
        onDirty(false);
        return true;
    }

    if (formError) {
        return (
        <div className='form-error-container'>
            <div className='form-error'>{formError}</div>
        </div>
        );
    } else {
        return (
            <SchemaSubmitForm {...{ schema, value }}
                onDirty={onDirty}
                onSubmit={onDoSubmit}
                makeSubmitLink={makeSubmitLink}
                collapsible={true}
            />
        );
    }
}